<template>
  <div>
    <CreateSubCategory
      :categoryId="categoryId"
      :id="id"
      v-on:close-modal="openSubCategory"
      v-if="subCategoryModal"
    />
    <div class="container container-dashboard">
      <div class="title">
        <h2>{{ categoryName }}</h2>
        <i
          v-if="isAdmin"
          @click="openSubCategory"
          class="fal fa-plus-circle"
        ></i>
        <i v-if="isAdmin" @click="deleteCategroy" class="fad fa-trash-alt"></i>
      </div>
      <div class="categorys">
        <ViewSubCategories
          v-bind:categoryName="categoryName"
          v-bind:categoryId="categoryId"
        />
        <ViewCategories
          v-bind:categoryName="categoryName"
          v-bind:categoryId="categoryId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import db from "../../firebase/init";
import CreateSubCategory from "./CreateSubCategory";
import ViewSubCategories from "./ViewSubCategories";
import ViewCategories from "./ViewCategories";
import { getUserInfo } from "../../mixins/getUserInfo";

export default {
  name: "ViewCategory",
  components: {
    ViewCategories,
    CreateSubCategory,
    ViewSubCategories,
  },
  mixins: [getUserInfo],
  data() {
    return {
      categoryName: null,
      categoryId: null,
      subCategoryModal: false,
    };
  },
  created() {
    this.fetchCategoryName(this.$route.params.categoryId);
  },
  methods: {
    fetchCategoryName(param) {
      db.collection("category")
        .doc(`${param}`)
        .get()
        .then((querySnapShot) => {
          this.categoryName = querySnapShot.data().name;
          this.categoryId = param;
        })
        .catch((err) => console.log(err));
    },
    deleteCategroy() {
      alert("About to delete categroy. Continue?");
      alert(
        "You are about to delete all documents in this category. This cannot be undone. Continue?"
      );
      const ref = db.collection("category").doc(`${this.categoryId}`);
      const getAllDocs = db
        .collection("documents")
        .where("categoryId", "==", this.categoryId);
      ref.delete().then(() => {
        this.$router.push({ name: "Category" });
      });
      getAllDocs.forEach((doc) => {
        doc.delete();
      });
    },
    openSubCategory() {
      this.subCategoryModal = !this.subCategoryModal;
    },
  },
};
</script>

<style lang="scss" scoped>
.type div {
  display: flex;
  flex-direction: row;
}

.name,
.type,
.number-items,
.date,
.created-by {
  flex: 2;
}

.url {
  flex: 1;
}
</style>
